<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card-box m-0" v-pml-block="loadingFilters">
                <form role="form" @submit.prevent="doFilter(1)">
                    <div class="form-group clearfix">
                        <div class="input-group">
                            <input type="text" v-model="filter.search" class="form-control input_search" :placeholder="$t('_deals.filter_main_field_placeholder')">
                            <span class="input-group-btn">
                                <span class="btn btn_green" @click.prevent="doFilter(1)" v-pml-tooltip="$t('filter')">
                                    <i class="fa fa-fw fa-search"></i>
                                </span>
                                <span class="btn btn_light" @click.prevent="showAdvancedFilter = !showAdvancedFilter" v-pml-tooltip="$t('filter_advanced')">
                                    <i class="fa fa-fw fa-chevron-up" :class="{ 'fa-chevron-down': !showAdvancedFilter }"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div v-show="showAdvancedFilter">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-6 m-b-15">
                                <label>{{ $t('entry_date') }}</label>
                                <div class="input-daterange input-group">
                                    <pml-date-picker v-model="filter.created_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.created_at_to"></pml-date-picker>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-6 m-b-15">
                                <label>{{ $t('last_change_date') }}</label>
                                <div class="input-daterange input-group" id="date-range2">
                                    <pml-date-picker v-model="filter.updated_at_from"></pml-date-picker>
                                    <span class="input-group-addon b-0"><i class="fa fa-calendar"></i></span>
                                    <pml-date-picker v-model="filter.updated_at_to"></pml-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('team') }}</label>
                                <pml-select v-model="filter.team_id" :options="teams"></pml-select>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('consultant') }}</label>
                                <pml-select-members v-model="filter.member_id" :allow-empty="true" :onlyActive="true"></pml-select-members>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('followed_by') }}</label>
                                <pml-select-members v-model="filter.follower_id" :allow-empty="true" :all="true" :only-follow="true" :onlyActive="true"></pml-select-members>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('status') }}</label>
                                <pml-multiselect v-model="filter.status_s" :options="status"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('perception') }}</label>
                                <pml-multiselect v-model="filter.perceptions" :options="perceptions"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('source') }}</label>
                                <pml-multiselect v-model="filter.sources" :options="sources"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('segment') }}</label>
                                <pml-multiselect v-model="filter.segments" :options="segments"></pml-multiselect>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 m-b-15">
                                <label>{{ $t('pipeline') }}</label>
                                <pml-select-group v-model="filter.pipeline_step_id" :options="pipelines" group-values="steps" group-label="name" class="select_pipeline"></pml-select-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 m-b-15">
                                <pml-checkbox v-model="filter.show_lonely" :label="$t('show_lonely_deals')"></pml-checkbox>
                            </div>
                        </div>
                        <div class="clearfix">
                            <span class="btn btn-white pull-left" @click="clear"><i class="fa fa-paint-brush m-r-5"></i> {{ $t('clear') }}</span>
                            <button class="btn btn_green pull-right" type="submit">
                                <span class="btn-label">
                                    <i class="fa fa-search"></i>
                                </span>
                                {{ $t('filter') }}
                            </button>
                        </div>
                    </div>
                </form>
                <hr>
                <div class="row t_lg_center">
                    <div class="col-md-12 col-lg-6 m_lg_bottom_10 clearfix">
                        <div class="btn-group pull-left pull_lg_none btn_mobile_block">
                            <button type="button" class="btn btn-primary btn-sm dropdown-toggle btn_mobile_block" data-toggle="dropdown" aria-expanded="false">{{ $t('sort_by') }}: {{ orderedBy }} <span class="caret"></span></button>
                            <ul class="dropdown-menu" role="menu">
                                <li><a href="#" @click.prevent="setOrderBy('updated_at', 'desc')">{{ $t('last_change_date') }}</a></li>
                                <li><a href="#" @click.prevent="setOrderBy('assigned_at', 'desc')">{{ $t('attribution_date') }}</a></li>
                                <li><a href="#" @click.prevent="setOrderBy('created_at', 'desc')">{{ $t('entry_date') }}</a></li>
                                <li><a href="#" @click.prevent="setOrderBy('perception', 'asc')">{{ $t('perception') }}</a></li>
                                <li><a href="#" @click.prevent="setOrderBy('member_id', 'asc')">{{ $t('consultant') }}</a></li>
                                <li><a href="#" @click.prevent="setOrderBy('source_id', 'asc')">{{ $t('source') }}</a></li>
                                <li><a href="#" @click.prevent="setOrderBy('segment_id', 'asc')">{{ $t('segment') }}</a></li>
                            </ul>
                        </div>
                        <span class="m-t-5 m-l-10 d_inline_b">{{ $t('data_grid_entries_showing_paginate', { from: pagination.from, to: pagination.to, total: pagination.total }) }}</span>
                    </div>
                    <div class="col-md-12 col-lg-6 t_right t_lg_center">
                        <button class="btn btn-white btn_mobile_block" @click.prevent="exportDeals()" v-pml-block="isExporting">
                            <i class="fa fa-fw fa-upload m-r-5"></i>
                            {{ $t('export') }}
                        </button>
                        <router-link :to="{ name: 'deals.transfer' }" v-if="member.is_admin" class="btn btn-warning btn_mobile_block">
                            <span class="btn-label">
                                <i class="fa fa-fw fa-exchange"></i>
                            </span>
                            {{ $t('transfer') }}
                        </router-link>
                        <router-link :to="{ name: 'deals.create' }" class="btn btn-default btn_mobile_block">
                            <span class="btn-label">
                                <i class="fa fa-fw fa-user-plus"></i>
                            </span>
                            {{ $t('lead') }}/{{ $t('deal') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getAllPaged, exportAll, transferAll } from 'services/deals'
    import { mapGetters } from 'vuex'
    import { isEmpty, forEach } from 'lodash'

    export default {
        name: 'DealsFilter',
        data () {
            return {
                page: 1,
                pagination: {
                    from: 0,
                    to: 0,
                    total: 0
                },
                showAdvancedFilter: false,
                isExporting: false,
                loadingFilters: false,
                filter: {
                    created_at_from: '',
                    created_at_to: '',
                    updated_at_from: '',
                    updated_at_to: '',
                    orderBy: 'updated_at',
                    orderDirection: 'desc',
                    team_id: '',
                    follower_id: '',
                    member_id: '',
                    perception: '',
                    source_id: '',
                    pipeline_step_id: '',
                    status_s: ['open'],
                    show_lonely: false
                }
            }
        },
        created () {
            bus.$on('doFilterDeals', this.doFilter)
            bus.$on('exportDeals', this.exportDeals)
            bus.$on('transferDeals', this.transferDeals)
        },
        destroyed () {
            bus.$off('doFilterDeals')
            bus.$off('exportDeals')
            bus.$off('transferDeals')
        },
        mounted () {
            this.initOrderLocalStorage()
            this.setSearchField()
            this.doFilter(1)
        },
        computed: {
            ...mapGetters({
                'perceptions': 'getDealPerceptions',
                'segments': 'getSegments',
                'sources': 'getSources',
                'members': 'getMembers',
                'member': 'getMember',
                'pipelines': 'getPipelines',
                'status': 'getDealStatus',
                'teams': 'getTeams'
            }),
            orderedBy () {
                if (this.filter.orderBy === 'first_name') return trans('name')
                if (this.filter.orderBy === 'updated_at') return trans('last_change_date')
                if (this.filter.orderBy === 'assigned_at') return trans('attribution_date')
                if (this.filter.orderBy === 'created_at') return trans('entry_date')
                if (this.filter.orderBy === 'perception') return trans('perception')
                if (this.filter.orderBy === 'member_id') return trans('consultant')
                if (this.filter.orderBy === 'source_id') return trans('source')
                if (this.filter.orderBy === 'segment_id') return trans('segment')
            }
        },
        watch: {
            '$route' (val, old) {
                if (val.query.search !== old.query.search) {
                    this.setSearchField()
                    this.doFilter(1)
                }
            }
        },
        methods: {
            setSearchField () {
                if (isEmpty(this.$route.query)) return

                forEach(this.$route.query, (val, index) => {
                    if (typeof this.filter[index] === 'object')
                        this.filter[index] = [val]
                    else
                        this.filter[index] = val
                })
            },
            initOrderLocalStorage () {
                let orderBy = window.localStorage.getItem('deal_filter_order_by') || 'updated_at'
                let orderDirection = window.localStorage.getItem('deal_filter_order_direction') || 'desc'

                this.filter.orderBy = orderBy
                this.filter.orderDirection = orderDirection
            },
            setOrderBy (orderBy, direction) {
                window.localStorage.setItem('deal_filter_order_by', orderBy)
                window.localStorage.setItem('deal_filter_order_direction', direction)

                this.filter.orderBy = orderBy
                this.filter.orderDirection = direction
                this.doFilter(1)
            },
            clear () {
                this.filter = {
                    created_at_from: '',
                    created_at_to: '',
                    updated_at_from: '',
                    updated_at_to: '',
                    orderBy: 'updated_at',
                    orderDirection: 'desc',
                    team_id: '',
                    follower_id: '',
                    member_id: '',
                    perception: '',
                    source_id: '',
                    segment_id: '',
                    status_s: ['open'],
                    show_lonely: false
                }
                this.doFilter(1)
            },
            doFilter (page = null) {
                bus.$emit('listLoadingDeals', true)

                this.page = page === null ? this.page : page

                getAllPaged(this.page, this.filter)
                    .then(response => {
                        this.pagination = response.data
                        bus.$emit('paginationRefreshDeals', response.data)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => bus.$emit('listLoadingDeals', false))
            },
            exportDeals () {
                this.isExporting = true
                Notify.info(trans('_notifications.export.wait'))
                exportAll(this.filter)
                    .catch(() => Notify.error(trans('_notifications.export.error'), {duration: -1}))
                    .then(() => {
                        Notify.success(trans('_notifications.export.success'), {icon: 'fa fa-upload', duration: -1})
                        this.isExporting = false
                    })
            },
            transferDeals (memberId) {
                this.loadingFilters = true
                Notify.info(trans('_notifications.wait'))
                transferAll({ member_id: memberId, filters: this.filter })
                    .then(() => {
                        Notify.success(trans('_notifications.success'), {icon: 'fa fa-exchange'})
                        this.doFilter(1)
                    })
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.loadingFilters = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/list/Filter.vue